import { render, staticRenderFns } from "./AbkNewEmployersBox.vue?vue&type=template&id=1ef9b8ee&scoped=true&"
import script from "./AbkNewEmployersBox.vue?vue&type=script&lang=js&"
export * from "./AbkNewEmployersBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewEmployersBox.vue?vue&type=style&index=0&id=1ef9b8ee&scoped=true&lang=scss&"
import style1 from "./AbkNewEmployersBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9b8ee",
  null
  
)

export default component.exports